(function () {
  'use strict';
  const drawer = document.querySelector('[data-bae-cart]');
  if (!drawer) return;

  /* Shipping is always free: no threshold, no progress calculation.
     The static "Gratis verzending" line is server-rendered in the drawer. */

  const body = drawer.querySelector('[data-bae-cart-body]');
  const foot = drawer.querySelector('[data-bae-cart-foot]');
  const subtotalEl = drawer.querySelector('[data-bae-subtotal]');
  const upsell = drawer.querySelector('[data-bae-upsell]');
  const upsellRow = drawer.querySelector('[data-bae-upsell-row]');
  const upsellHeading = drawer.querySelector('[data-bae-upsell-heading]') || (upsell && upsell.querySelector('.bae-kicker'));
  const defaultHeading = upsellHeading ? upsellHeading.textContent : '';
  const offerNote = drawer.querySelector('[data-bae-offer-note]');
  const giftEl = drawer.querySelector('[data-bae-gift]');
  const giftTextEl = drawer.querySelector('[data-bae-gift-text]');
  const giftBarWrap = drawer.querySelector('[data-bae-gift-barwrap]');
  const giftBar = drawer.querySelector('[data-bae-gift-bar]');
  const giftSubEl = drawer.querySelector('[data-bae-gift-sub]');

  function readJSON(sel, fallback) {
    const el = document.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }
  const catalogue = readJSON('[data-bae-catalogue]', []);
  const rules = readJSON('[data-bae-upsell-rules]', { accessoryTypes: ['Caps', 'Shorts', 'Socks'], maxSlots: 3 });
  const accessoryTypes = (rules.accessoryTypes || []).map((t) => String(t).trim()).filter(Boolean);

  const money = (c) => (c / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
  });
  const norm = (s) => String(s || '').trim().toLowerCase();
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  /* Cart-upsell images only. Every upsell image URL is requested at width 300;
     imageH is that image's real height at that width, server-rendered from the
     product's Shopify aspect ratio. Declaring the true intrinsic size, loading
     the handful of visible upsell images eagerly and decoding them off the main
     thread gives WebKit a definite, correct box to decode into. The visible box
     stays owned by `.bae-us img` in baesole-cart.css. */
  const imgAttrs = (p) => (Number(p && p.imageH) > 0 ? ' width="300" height="' + Number(p.imageH) + '"' : '') + ' loading="eager" decoding="async"';

  /* ---------- Tee + Cap offer (same module, no second upsell) ----------
     Identification comes from the same collections as the Shopify automatic
     discount (tees → caps). The "voordeel toegepast" confirmation is rendered
     only when /cart.js reports a real discount allocation on the cap line. */
  const offer = readJSON('[data-bae-offer]', null);
  const offerOn = !!(offer && offer.enabled && offer.caps && offer.caps.length && offer.tees && offer.tees.length);
  const teeSet = new Set(offerOn ? offer.tees.map(norm) : []);
  const capSet = new Set(offerOn ? offer.caps.map((c) => norm(c.handle)) : []);
  const offerDiscount = offer && Number(offer.discount) > 0 ? Number(offer.discount) : 0;

  /* ---------- Fixed BAESOLÉ matching sets (tee colour → shorts colour) ----
     Tee colour comes from custom.colour, shorts colour from custom.swatch_color;
     both are server-rendered into the catalogue/offer data. Only Black and
     Vintage Black are true colour sets — Crème, White and Dark Green are
     deliberately styled with Black shorts. */
  const teeColours = (offer && offer.teeColours) || {};
  const SHORTS_MATCH = {
    'black': 'black',
    'vintage black': 'vintage black',
    'crème': 'black',
    'creme': 'black',
    'cream': 'black',
    'white': 'black',
    'dark green': 'black'
  };
  function mappedShortsColour(cart) {
    const teeLine = cart.items.filter((i) => teeSet.has(norm(i.handle)))[0];
    if (!teeLine) return '';
    return SHORTS_MATCH[norm(teeColours[norm(teeLine.handle)])] || '';
  }

  function hasTee(cart) {
    return cart.items.some((i) => teeSet.has(norm(i.handle)));
  }
  function capLines(cart) {
    return cart.items.filter((i) => capSet.has(norm(i.handle)));
  }
  function lineDiscount(item) {
    const allocs = item.line_level_discount_allocations || item.discounts || [];
    let total = 0;
    allocs.forEach((a) => { total += Number((a && a.amount) || 0); });
    if (!total) total = Number(item.total_discount || 0);
    return total;
  }
  function capDiscountApplied(cart) {
    return capLines(cart).some((i) => lineDiscount(i) > 0);
  }

  /* ---------- Free cap from €100 ----------------------------------------
     One Shopify automatic discount ("Gratis cap vanaf €100") gives 1 cap at
     100% off above the threshold. Because that cap is the reward, Shopify does
     not count it towards the €100 — the progress below mirrors that exactly.
     The "toegevoegd" state comes only from the real allocation on the cap line. */
  const giftThreshold = offer && Number(offer.giftThreshold) > 0 ? Number(offer.giftThreshold) : 0;
  const giftOn = !!(offerOn && offer.giftEnabled && giftThreshold > 0);
  const moneyNL = (c) => (c / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });

  function giftState(cart) {
    if (!giftOn || !cart.items.length) return null;
    const caps = capLines(cart);
    let applied = false;
    const units = [];
    caps.forEach((i) => {
      const unit = Number(i.original_price || i.price || 0);
      if (lineDiscount(i) >= unit && unit > 0) applied = true;
      for (let n = 0; n < i.quantity; n++) units.push(unit);
    });
    const reserve = units.length ? Math.max.apply(null, units) : 0;
    const qualifying = Math.max(0, Number(cart.original_total_price || 0) - reserve);
    return {
      applied: applied,
      qualifying: qualifying,
      unlocked: qualifying >= giftThreshold,
      remaining: Math.max(0, giftThreshold - qualifying)
    };
  }

  function renderGift(state) {
    if (!giftEl) return;
    if (!state) { giftEl.hidden = true; return; }
    giftEl.hidden = false;
    giftEl.classList.toggle('bae-cart__gift--done', !!(state.applied || state.unlocked));
    if (state.applied) {
      giftTextEl.textContent = '✓ ' + (offer.giftApplied || '');
      if (giftBarWrap) giftBarWrap.hidden = true;
      giftSubEl.textContent = '';
      giftSubEl.hidden = true;
      return;
    }
    if (state.unlocked) {
      giftTextEl.textContent = '✓ ' + (offer.giftUnlocked || '');
      if (giftBarWrap) giftBarWrap.hidden = true;
      giftSubEl.textContent = offer.giftUnlockedSub || '';
      giftSubEl.hidden = !offer.giftUnlockedSub;
      return;
    }
    giftTextEl.textContent = String(offer.giftProgress || '').replace('%bedrag%', moneyNL(state.remaining));
    if (giftBarWrap) {
      giftBarWrap.hidden = false;
      giftBar.style.width = Math.min(100, Math.round(state.qualifying * 100 / giftThreshold)) + '%';
    }
    giftSubEl.textContent = offer.giftSub || '';
    giftSubEl.hidden = !offer.giftSub;
  }
  /* ---------------------------------------------------------------------- */

  function setHeading(text) {
    if (upsellHeading) upsellHeading.textContent = text;
  }
  function setNote(text) {
    if (!offerNote) return;
    offerNote.textContent = text || '';
    offerNote.hidden = !text;
  }

  function renderOffer(cart) {
    if (!offerOn || !cart.items.length) return false;

    const inCart = new Set(cart.items.map((i) => norm(i.handle)));
    const capsInCart = capLines(cart);
    const teeInCart = hasTee(cart);

    /* From €100 the free cap is the dominant reward: it replaces the €10
       Tee + Cap upsell in this module (the two discounts never stack). */
    const gift = giftState(cart);
    if (gift && gift.applied) { setNote(''); return false; }
    if (gift && gift.unlocked) {
      const giftPicks = offer.caps.filter((c) => !inCart.has(norm(c.handle))).slice(0, rules.maxSlots || 3);
      if (!giftPicks.length) return false;
      setHeading(offer.heading || defaultHeading);
      setNote('');
      upsell.hidden = false;
      upsellRow.innerHTML = giftPicks.map((p) =>
        '<div class="bae-us bae-us--gift">' +
        '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt=""' + imgAttrs(p) + '></a>' +
        '<a class="bae-us__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="bae-us__price"><del>' + money(p.price) + '</del>' +
        '<span class="bae-us__free">' + esc(offer.giftFree) + '</span></span>' +
        '<button class="bae-us__add" type="button" data-add-id="' + esc(p.id) + '">' + esc(offer.giftButton) + '</button>' +
        '</div>').join('');
      return true;
    }

    if (teeInCart && capsInCart.length) {
      /* Only claim the advantage when Shopify actually allocated it. */
      if (!capDiscountApplied(cart)) return false;
      setHeading(offer.heading || defaultHeading);
      setNote('');
      upsell.hidden = false;
      upsellRow.innerHTML = '<p class="bae-cart__offerdone"><span class="bae-cart__offercheck" aria-hidden="true">✓</span>' + esc(offer.confirm) + '</p>';
      return true;
    }

    /* Cap in the cart, no tee yet: same module, tees at their NORMAL price.
       Shopify allocates the €10 to the cap line, so a tee is never shown as
       €10 cheaper — the advantage is stated in one line instead. */
    if (!teeInCart && capsInCart.length) {
      const teePicks = (offer.teeUpsell || []).filter((t) => !inCart.has(norm(t.handle))).slice(0, rules.maxSlots || 3);
      if (!teePicks.length) return false;
      setHeading(offer.heading || defaultHeading);
      setNote(offer.teeNote);
      upsell.hidden = false;
      upsellRow.innerHTML = teePicks.map((p) =>
        '<div class="bae-us">' +
        '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt=""' + imgAttrs(p) + '></a>' +
        '<a class="bae-us__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="bae-us__price">' + money(p.price) + '</span>' +
        '<a class="bae-us__add" href="' + esc(p.url) + '">Toevoegen</a>' +
        '</div>').join('');
      return true;
    }

    if (!teeInCart) return false;

    /* Slot 1 is the matching shorts from the existing colour mapping, slots 2
       and 3 stay the existing Tee + Cap selection. Without a mapped, available
       shorts product the existing three-cap behaviour is kept unchanged. */
    const shortsColour = mappedShortsColour(cart);
    const matchShorts = shortsColour
      ? catalogue.filter((p) => norm(p.type) === 'shorts' && norm(p.colour) === shortsColour && !inCart.has(norm(p.handle)))[0]
      : null;
    const capSlots = matchShorts ? Math.max(0, (rules.maxSlots || 3) - 1) : (rules.maxSlots || 3);
    const picks = offer.caps.filter((c) => !inCart.has(norm(c.handle))).slice(0, capSlots);
    if (!picks.length && !matchShorts) return false;

    setHeading(offer.heading || defaultHeading);
    setNote('');
    upsell.hidden = false;
    const shortsCard = matchShorts
      ? '<div class="bae-us">' +
        '<a href="' + esc(matchShorts.url) + '"><img src="' + esc(matchShorts.image) + '" alt=""' + imgAttrs(matchShorts) + '></a>' +
        '<a class="bae-us__name" href="' + esc(matchShorts.url) + '">' + esc(matchShorts.title) + '</a>' +
        '<span class="bae-us__price">' + money(matchShorts.price) + '</span>' +
        (matchShorts.variants > 1
          ? '<a class="bae-us__add" href="' + esc(matchShorts.url) + '">Kies maat</a>'
          : '<button class="bae-us__add" type="button" data-add-id="' + esc(matchShorts.id) + '">Toevoegen</button>') +
        '</div>'
      : '';
    upsellRow.innerHTML = shortsCard + picks.map((p) => {
      const now = Math.max(0, Number(p.price) - offerDiscount);
      return '<div class="bae-us bae-us--offer">' +
        '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt=""' + imgAttrs(p) + '></a>' +
        '<a class="bae-us__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="bae-us__price">' +
        '<del>' + money(p.price) + '</del> <ins>' + money(now) + '</ins>' +
        '<span class="bae-us__suffix">' + esc(offer.suffix) + '</span>' +
        '</span>' +
        (p.variants > 1
          ? '<a class="bae-us__add" href="' + esc(p.url) + '">Kies maat</a>'
          : '<button class="bae-us__add" type="button" data-add-id="' + esc(p.id) + '">Toevoegen</button>') +
        '</div>';
    }).join('');
    return true;
  }
  /* -------------------------------------------------------------------- */

  function open() {
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    refresh();
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, 340);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-bae-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-bae-cart-close]')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  function renderItems(cart) {
    if (!cart.items.length) {
      body.innerHTML = '<p class="bae-cart__empty">Je tas is leeg.<br><br><a class="bae-link" href="/collections/all">Begin met shoppen</a></p>';
      foot.hidden = true;
      if (upsell) upsell.hidden = true;
      return;
    }
    foot.hidden = false;

    body.innerHTML = cart.items.map((item, i) => {
      /* Shopify's placeholder "Default Title" (single-variant products such
         as socks) is never a real option value, so it is not printed. */
      const opts = (item.options_with_values || []).map((o) => o.value).filter((v) => v && v !== 'Default Title').join(' · ');
      /* Struck-through price only when Shopify itself allocated a discount
         to this line — the amounts come straight from /cart.js. */
      const priceCell = lineDiscount(item) > 0
        ? '<span class="bae-ci__price bae-ci__price--disc"><del>' + money(item.original_line_price) + '</del> <ins>' + money(item.final_line_price) + '</ins></span>'
        : '<span class="bae-ci__price">' + money(item.final_line_price) + '</span>';
      return '<div class="bae-ci" data-line="' + (i + 1) + '">' +
        '<a href="' + item.url + '"><img class="bae-ci__img" src="' + (item.image ? item.image + '&width=200' : '') + '" alt="" loading="lazy"></a>' +
        '<div><a class="bae-ci__name" href="' + item.url + '">' + item.product_title + '</a>' +
        '<p class="bae-ci__meta">' + opts + '</p>' +
        '<div class="bae-ci__row"><span class="bae-ci__qty">' +
        '<button type="button" data-qty="' + (item.quantity - 1) + '" aria-label="Minder">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-qty="' + (item.quantity + 1) + '" aria-label="Meer">+</button>' +
        '</span>' + priceCell + '</div>' +
        '<button class="bae-ci__remove" type="button" data-qty="0">Verwijderen</button>' +
        '</div></div>';
    }).join('');

    subtotalEl.textContent = money(cart.total_price);
  }

  function pickUpsell(cart) {
    const inCart = new Set(cart.items.map((i) => i.handle));
    const typesInCart = new Set(cart.items.map((i) => norm(i.product_type)));
    const available = catalogue.filter((p) => !inCart.has(p.handle));
    const picks = [];
    const used = new Set();

    const mainType = norm(cart.items[0] && cart.items[0].product_type);
    if (mainType) {
      const same = available.find((p) => norm(p.type) === mainType && !used.has(p.handle));
      if (same) { picks.push(same); used.add(same.handle); }
    }

    const shortsColour = mappedShortsColour(cart);
    accessoryTypes.forEach((type) => {
      if (picks.length >= (rules.maxSlots || 3)) return;
      const t = norm(type);
      if (t === mainType || typesInCart.has(t)) return;
      /* Shorts follow the fixed matching set when a tee is in the cart. */
      let found = null;
      if (t === 'shorts' && shortsColour) {
        found = available.find((p) => norm(p.type) === t && norm(p.colour) === shortsColour && !used.has(p.handle));
      }
      if (!found) found = available.find((p) => norm(p.type) === t && !used.has(p.handle));
      if (found) { picks.push(found); used.add(found.handle); }
    });

    if (picks.length < (rules.maxSlots || 3)) {
      available.forEach((p) => {
        if (picks.length >= (rules.maxSlots || 3)) return;
        if (used.has(p.handle)) return;
        picks.push(p);
        used.add(p.handle);
      });
    }
    return picks.slice(0, rules.maxSlots || 3);
  }

  function renderUpsell(cart) {
    if (!upsell) return;
    if (!cart.items.length) { upsell.hidden = true; setNote(''); return; }
    if (renderOffer(cart)) return;
    setHeading(defaultHeading);
    setNote('');
    if (!catalogue.length) { upsell.hidden = true; return; }
    const picks = pickUpsell(cart);
    if (!picks.length) { upsell.hidden = true; return; }
    upsell.hidden = false;
    upsellRow.innerHTML = picks.map((p) =>
      '<div class="bae-us">' +
      '<a href="' + p.url + '"><img src="' + p.image + '" alt=""' + imgAttrs(p) + '></a>' +
      '<a class="bae-us__name" href="' + p.url + '">' + p.title + '</a>' +
      '<span class="bae-us__price">' + money(p.price) + '</span>' +
      (p.variants > 1
        ? '<a class="bae-us__add" href="' + p.url + '">Kies maat</a>'
        : '<button class="bae-us__add" type="button" data-add-id="' + p.id + '">Toevoegen</button>') +
      '</div>').join('');
  }

  function syncCounts(cart) {
    document.querySelectorAll('[data-bae-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  function paint(cart) {
    renderItems(cart);
    renderGift(giftState(cart));
    renderUpsell(cart);
    syncCounts(cart);
  }

  function refresh() {
    return fetch('/cart.js').then((r) => r.json()).then(paint);
  }

  function change(line, quantity) {
    body.style.opacity = '.5';
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then((r) => r.json())
      .then((cart) => { body.style.opacity = ''; paint(cart); })
      .catch(() => { body.style.opacity = ''; });
  }

  drawer.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      change(Number(qtyBtn.closest('[data-line]').dataset.line), Number(qtyBtn.dataset.qty));
      return;
    }
    const addBtn = e.target.closest('[data-add-id]');
    if (addBtn) {
      addBtn.textContent = 'Toevoegen…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addBtn.dataset.addId), quantity: 1 }] })
      }).then(() => refresh());
    }
  });

  document.addEventListener('bae:cart:updated', () => {
    if (drawer.classList.contains('is-open')) refresh();
    else open();
  });
})();

/* --------------------------------------------------------------------------
   Recommendation rail scroll indicator ("Maak je look compleet").
   ISOLATED presentation-only block: it reads the rail's scroll geometry and
   paints a track/thumb underneath it. It never touches cart state, gifts,
   discounts, quantities or which products render — those all live in the
   module above and are unchanged. No polling: scroll + resize + a childList
   MutationObserver (the rail is re-rendered via innerHTML on every cart
   update), throttled through requestAnimationFrame. Hidden entirely when
   every card fits inside the visible rail. */
(function () {
  'use strict';
  var rail = document.querySelector('[data-bae-upsell-row]');
  if (!rail) return;

  var bar = document.createElement('div');
  bar.className = 'bae-cart__railbar';
  bar.setAttribute('aria-hidden', 'true');
  bar.hidden = true;
  var thumb = document.createElement('span');
  bar.appendChild(thumb);
  rail.insertAdjacentElement('afterend', bar);

  var raf = 0;
  function update() {
    raf = 0;
    var total = rail.scrollWidth;
    var view = rail.clientWidth;
    if (view === 0 || total <= view + 1) { bar.hidden = true; return; }
    bar.hidden = false;
    var w = Math.max(0, Math.min(1, view / total)) * 100;      /* visible / total   */
    var max = total - view;                                     /* max scrollLeft    */
    var x = max > 0 ? Math.max(0, Math.min(1, rail.scrollLeft / max)) : 0;
    thumb.style.width = w + '%';
    thumb.style.left = (x * (100 - w)) + '%';                   /* progress of track */
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(update); }

  rail.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(rail, { childList: true });
  document.addEventListener('bae:cart:updated', schedule);
  schedule();
})();
